<template>
  <div id="ma-facilities-wrap">

    <!-- ── 헤더 ── -->
    <div class="mf-header">
      <div class="mf-title">
        <span class="mf-title-icon">🏨</span>
        시설코드 한국어 관리 <span style="font-size:0.9rem; color: red;"> (※국문미입력된 시설은 영문으로 표시처리)</span>
        <span class="mf-count" v-if="rowData.length">{{ rowData.length }}개</span>
      </div>
      <div class="mf-actions">
        <span class="mf-changed-badge" v-if="changedRows.size > 0">
          {{ changedRows.size }}건 변경됨
        </span>
        <button class="mf-btn-reset" @click="resetChanges" :disabled="changedRows.size === 0">
          되돌리기
        </button>
        <button class="mf-btn-save" @click="saveAll" :disabled="changedRows.size === 0 || saving">
          <span v-if="saving">저장 중...</span>
          <span v-else>💾 저장 ({{ changedRows.size }}건)</span>
        </button>
      </div>
    </div>

    <!-- ── 필터 바 ── -->
    <div class="mf-filter-bar">
      <input v-model="filterText" class="mf-filter-input" placeholder="🔍  영문명 또는 한국어로 검색..." @input="onFilterChanged"/>
      <label class="mf-check-label">
        <input type="checkbox" v-model="showEmptyOnly" @change="onFilterChanged" />
        한국어 미입력만 보기
      </label>
    </div>

    <!-- ── AG Grid ── -->
    <div class="mf-grid-wrap">
      <ag-grid-vue class="ag-theme-alpine mf-grid"
        :rowData="rowData"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :isExternalFilterPresent="isExternalFilterPresent"
        :doesExternalFilterPass="doesExternalFilterPass"
        :enableCellTextSelection="true"
        :ensureDomOrder="true"
        @grid-ready="onGridReady"
        @cell-clicked="onCellClicked"
        @cell-value-changed="onCellValueChanged"
        rowHeight="44"
        headerHeight="46"
      />
    </div>

  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3';

export default {
  name: 'Ma_RtxFacilitiesCode',
  components: { AgGridVue },

  data() {
    return {
      gridApi: null,
      rowData: [],
      originalData: {},       // { facility_code: description_ko } 원본 보관
      changedRows: new Map(), // { facility_code: description_ko } 변경 추적
      filterText: '',
      showEmptyOnly: false,
      saving: false,

      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMovable: true,
      },

      columnDefs: [
        {
          headerName: 'CODE',
          field: 'facility_code',
          width: 90,
          pinned: 'left',
          cellStyle: { fontWeight: '600', color: '#86cd53', textAlign: 'center' },
        },
        {
          headerName: '영문 시설명',
          field: 'description',
          flex: 1,
          minWidth: 200,
        },
        {
          headerName: '한국어 시설명',
          field: 'description_ko',
          flex: 1,
          minWidth: 180,
          editable: true,
          cellStyle: { backgroundColor: '#f9fff5' },
          cellRenderer: (params) => {
            if (!params.value) {
              return `<span style="color:#ccc;font-style:italic;">클릭하여 입력...</span>`;
            }
            return params.value;
          },
        },
        {
          headerName: '조건검색표시',
          field: 'viewSearch',
          width: 120,
          cellStyle: { textAlign: 'center', cursor: 'pointer' },
          cellRenderer: (params) => {
            const checked = params.value === 'Y';   // Y만 체크, N·Null 모두 비체크
            return `<input type="checkbox" ${checked ? 'checked' : ''}
              style="transform:scale(1.3); cursor:pointer; pointer-events:none;" />`;
          },
        },
        {
          headerName: '객실시설',
          field: 'is_for_room',
          width: 90,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => params.value ? '✅' : '—',
        },
        {
          headerName: '최종 수정',
          field: 'updDate_ko',
          width: 150,
          cellRenderer: (params) => {
            if (!params.value) return '<span style="color:#ccc">—</span>';
            return new Date(params.value).toLocaleDateString('ko-KR');
          },
        },
        {
          headerName: '수정자',
          field: 'updId_ko',
          width: 100,
          cellRenderer: (params) => params.value || '<span style="color:#ccc">—</span>',
        },
      ],
    };
  },

  created() {
    this.user = this.$store.state.user;
    console.log('현재 사용자 정보:', this.user)
  },

  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }
    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";

    this.loadData();

    // 그리드 영역에서 전역 이벤트 차단 무력화
    this.$nextTick(() => {
      const gridEl = this.$el.querySelector('.mf-grid-wrap');
      if (gridEl) {
        gridEl.addEventListener('mousedown', e => e.stopPropagation(), true);
        gridEl.addEventListener('selectstart', e => e.stopPropagation(), true);
      }
    });
  },

  methods: {
    // ── 데이터 로드 ──────────────────────────────────
    async loadData() {
      try 
      {
        const res = await this.$api("/api/getFacilitiesInfo", { param: [] });
        console.log('시설코드 데이터:', res);

        if (res.length > 0) {
          this.rowData = res;
          // 원본 저장
          this.rowData.forEach(row => {
            this.originalData[row.facility_code] = {
              description_ko: row.description_ko || '',
              viewSearch:     row.viewSearch ?? null,   // null 원본 유지
            };
          });
        }
      } 
      catch (e) 
      {
        console.error('시설코드 로드 실패:', e);
        alert('데이터 로드에 실패했습니다.');
      }
    },

    // ── 그리드 준비 ──────────────────────────────────
    onGridReady(params) {
      this.gridApi = params.api;
    },

    onCellClicked(params) {
      if (params.column.getColId() !== 'viewSearch') return;

      // Y → N,  Null·N → Y
      const newVal = params.data.viewSearch === 'Y' ? 'N' : 'Y';
      params.node.setDataValue('viewSearch', newVal);
    },

    // ── 셀 값 변경 추적 ──────────────────────────────
    onCellValueChanged(params) {
      const code  = params.data.facility_code;
      const field = params.column.getColId();
      const orig  = this.originalData[code] || {};

      const current = this.changedRows.get(code) || {
        description_ko: params.data.description_ko || '',
        viewSearch:     params.data.viewSearch ?? null,
      };
      current[field] = params.newValue ?? null;

      // 원본이 null이고 N으로 바뀐 경우 → 실질적 변화 없음 처리 여부 선택
      const origView    = orig.viewSearch ?? null;
      const currentView = current.viewSearch ?? null;

      const hasChange =
        current.description_ko !== (orig.description_ko ?? '') ||
        currentView             !== origView;

      if (hasChange) 
      {
        this.changedRows.set(code, current);
      } 
      else 
      {
        this.changedRows.delete(code);
      }
      this.changedRows = new Map(this.changedRows);
    },

    // ── 저장 ─────────────────────────────────────────
    async saveAll() {
      if (this.changedRows.size === 0) return;
      this.saving = true;

      const items = [];
      this.changedRows.forEach((val, facility_code) => {
        items.push({
          facility_code,
          description_ko: val.description_ko,
          viewSearch:     val.viewSearch ?? null
        });
      });

      try {
        let successCount = 0;

        for (const item of items) {                          // ✅ 건별 루프
          const res = await this.$api('/api/updateFacilities_ko', {
            param: [
              item.description_ko,                           // ✅ item. 으로 접근
              item.viewSearch,
              this.$store.state.user?.handlerId || 'System',
              item.facility_code                             // ✅ item. 으로 접근
            ]
          });
          if (res.affectedRows > 0) successCount++;
        }

        if (successCount > 0) 
        {
          items.forEach(item => {
            this.originalData[item.facility_code] = item.description_ko;
          });
          this.changedRows.clear();
          this.changedRows = new Map();
          alert(`✅ ${successCount}건 저장 완료`);

          this.loadData(); // 화면반영
        } 
        else 
        {
          alert('저장된 항목이 없습니다.');
        }

      } 
      catch (e) 
      {
        console.error('저장 실패:', e);
        alert('저장 중 오류가 발생했습니다.');
      } 
      finally 
      {
        this.saving = false;
      }
    },

    // ── 변경 되돌리기 ────────────────────────────────
    resetChanges() {
      if (!confirm('변경 내용을 되돌리시겠습니까?')) return;

      this.changedRows.forEach((_, code) => {
        const idx  = this.rowData.findIndex(r => r.facility_code === code).toString();
        const node = this.gridApi.getRowNode(idx);
        if (node) {
          const orig = this.originalData[code];
          node.setDataValue('description_ko', orig.description_ko);
          node.setDataValue('viewSearch',     orig.viewSearch);
        }
      });

      this.changedRows.clear();
      this.changedRows = new Map();
    },

    // ── 키워드검색 ────────────────────────────────────
    onFilterChanged() {
      this.gridApi?.onFilterChanged();
    },

    isExternalFilterPresent() {
      return this.filterText.trim() !== '' || this.showEmptyOnly;
    },

    doesExternalFilterPass(node) {
      const row = node.data;
      const keyword = this.filterText.trim().toLowerCase();

      if (this.showEmptyOnly && row.description_ko) return false;

      if (keyword) {
        const enMatch = (row.description    || '').toLowerCase().includes(keyword);
        const koMatch = (row.description_ko || '').toLowerCase().includes(keyword);
        return enMatch || koMatch;
      }
      return true;
    },
  },
};
</script>

<style scoped>
#ma-facilities-wrap {
  padding: 24px;
  background: #f5f7fa;
  min-height: 100vh;
  font-family: 'Noto Sans KR', sans-serif;
}

/* ── 헤더 ── */
.mf-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.mf-title {
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
  display: flex;
  align-items: center;
  gap: 8px;
}

.mf-title-icon { font-size: 22px; }

.mf-count {
  font-size: 13px;
  font-weight: 500;
  color: #86cd53;
  background: #f0fde7;
  border: 1px solid #86cd53;
  border-radius: 12px;
  padding: 2px 10px;
}

/* ── 액션 버튼 ── */
.mf-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mf-changed-badge {
  font-size: 13px;
  font-weight: 600;
  color: #e67e22;
  background: #fef9e7;
  border: 1px solid #f39c12;
  border-radius: 12px;
  padding: 3px 12px;
}

.mf-btn-reset, .mf-btn-save {
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.mf-btn-reset {
  background: #fff;
  color: #718096;
  border: 1px solid #e2e8f0;
}
.mf-btn-reset:hover:not(:disabled) {
  background: #edf2f7;
}

.mf-btn-save {
  background: #86cd53;
  color: #fff;
}
.mf-btn-save:hover:not(:disabled) {
  background: #6fb340;
}

.mf-btn-reset:disabled, .mf-btn-save:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── 필터 바 ── */
.mf-filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 16px;
}

.mf-filter-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: #2d3748;
  background: transparent;
}

.mf-check-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #718096;
  cursor: pointer;
  white-space: nowrap;
}

.mf-check-label input { accent-color: #86cd53; cursor: pointer; }

/* ── 그리드 ── */
.mf-grid-wrap {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  user-select: text !important;               /* 좌클릭제한무시 */
  -webkit-user-select: text !important;  
}

.mf-grid {
  width: 100%;
  height: calc(100vh - 220px);
  min-height: 400px;
}

/* 이걸로 교체 */
:deep(.ag-cell) {
  user-select: text !important;
  -webkit-user-select: text !important;
  cursor: text;
}

:deep(.ag-center-cols-container),
:deep(.ag-pinned-left-cols-container) {
  user-select: text !important;
  -webkit-user-select: text !important;
}
</style>
